import * as Yup from 'yup';

export const supplierSpecialOffersOverviewValidationSchema = Yup.object().shape({
    supplier: Yup.object().typeError('app.error.required').required('app.error.required'),
    path: Yup.string().required('app.error.required'),
    validFrom: Yup.date().required('app.error.required').typeError('app.error.required'),
    validTo: Yup.date()
        .required('app.error.required')
        .typeError('app.error.required')
        .min(Yup.ref('validFrom'), 'app.error.afterValidFrom'),
    title: Yup.string().required('app.error.required'),
    subtitle: Yup.string().required('app.error.required'),
});
